// extracted by mini-css-extract-plugin
export default {"row":"FileRow_row__kTmei","text":"FileRow_text__qUrlN"};